var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"QRCode"},[_c('div',{attrs:{"id":"qrCode"}}),_c('h3',{staticClass:"lobbyCode font-color--primary font-style--readable"},[_vm._v(_vm._s(_vm.gameId))])])}
var staticRenderFns = []

export { render, staticRenderFns }